<script lang="ts" setup>
import type { ReviewRubric } from "#modules/review/review-rubric.types";
import { getRubricSectionItems } from "#modules/review/review.utils";

interface ReviewRubricListProps {
  rubric: ReviewRubric;
}

withDefaults(defineProps<ReviewRubricListProps>(), {});
</script>

<template>
  <div class="rubric">
    <VExpansionPanels multiple variant="accordion">
      <VExpansionPanel
        v-for="section in rubric.sections"
        :key="section.name"
        class="rubric-section"
      >
        <slot name="title">
          <VExpansionPanelTitle class="rubric-section-title text-subtitle-2" static>
            {{ section.name }}
          </VExpansionPanelTitle>
        </slot>
        <slot name="text">
          <VExpansionPanelText class="rubric-section-item">
            <LayoutStack
              v-for="(item, itemIdx) in getRubricSectionItems(section)"
              :key="itemIdx"
              align-items="center"
              class="text-body-2"
              direction="row"
              justify-content="space-between"
            >
              <span>{{ item.description }}</span>
              <span class="ml-2 text-subtitle-2">{{ item.weight }}</span>
            </LayoutStack>
          </VExpansionPanelText>
        </slot>
      </VExpansionPanel>
    </VExpansionPanels>
  </div>
</template>

<style lang="scss" scoped>
.rubric-section-title {
  min-height: 40px;
  padding: spacing(2) spacing(3);
}

.rubric-section-item {
  :deep(> div) {
    padding: spacing(2) spacing(3);
    padding-top: 0;
  }
}
</style>
